<template>
  <div class="er-bottombar">
    <!-- Services -->
    <ul>
      <li v-for="(link, index) in navLinks" :key="index">
        <router-link
          :to="serviceRoute(link)"
          :class="isActiveRoute(link) ? 'er-sidebar__active-items' : ''"
          class="er-sidebar__none-active-items cs-textstyle-paragraph"
        >
          <span class="er-sidebar__items">
            <i v-if="link.icon" :class="link.icon" />
            {{ link.text }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {},
  data() {
    return {
      navLinks: [
        {
          text: 'Notifications',
          path: 'notifications',
          name: 'Notifications',
          icon: 'cs-icons-notification-filled',
        },
        {
          text: 'Analytics',
          path: 'analytics',
          name: 'Analytics',
          icon: 'cs-icons-report-filled',
        },
      ],
    };
  },
  methods: {
    isActiveRoute(link) {
      if (!this.$route.name) return false;
      return this.$route.name.toLowerCase().includes(link.name.toLowerCase());
    },
    serviceRoute(link) {
      const path = link.extra ? `${link.path}/${link.extra}` : link.path;
      return `/${path}`;
    },
  },
};
</script>

<style scoped>
.er-bottombar {
  display: flex;
  flex-direction: row;
  background: var(--cs-primary-base);
  position: fixed;
  bottom: 0px;
  width: 100%;
  justify-content: center;
}

ul {
  display: flex;
  align-items: center;
  padding-inline-start: 0;
  flex-direction: row;
  margin: 0px;
  justify-content: center;
}
a {
  text-decoration: none;
  display: flex;
  align-items: center;
  color: white;
}
a:hover {
  color: var(--cs-gray-00);
}
i,
.er-sidebar__item-icon-svg {
  font-size: 22px;
}
.er-sidebar__item-icon-svg {
  width: 20px;
  margin-top: -8px;
}
li {
  list-style-type: none;
  width: 100%;
  display: flex;
  justify-content: center;
}
.er-sidebar__active-items {
  background-color: var(--cs-primary-base) !important;
  color: var(--cs-gray-00) !important;
  border-color: inherit !important;
}
.er-sidebar__sub-active-items {
  background-color: var(--cs-primary-dark) !important;
  color: var(--cs-gray-06) !important;
  border-color: inherit !important;
}
.er-sidebar__items {
  padding: 5px 20px;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.er-sidebar__none-active-items {
  background: transparent;
  color: var(--cs-gray-03);
}
</style>
